import { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useCart } from '../../../lib/context/cart/CartContext';
import { useChat } from '../../../lib/context/chat/ChatContext';

import styles from './CartProgress.module.css';

export const CartProgress: FC = () => {
    const { getCartCount } = useCart();
    const { plan } = useChat();
    const cartQty = getCartCount();
    const [showCart, setShowCart] = useState(false);
    const [initialized, setInitialized] = useState(false);

    const totalMeals = plan?.mealsPerDelivery || 0;
    const filledPercentage = totalMeals > 0 ? (cartQty / totalMeals) * 100 : 0;
    const remainingMeals = (plan?.mealsPerDelivery || 0) - cartQty;

    useEffect(() => {
        if (cartQty > 0 && initialized) {
            setShowCart(true);
            const timeoutId = setTimeout(() => {
                setShowCart(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        } else {
            setInitialized(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartQty]);

    return (
        <>
            <div className={classNames({
                [styles.cartProgress]: true,
                [styles.cartProgressShow]: showCart
            })}>
                <p className='title'>{cartQty} Items</p>
                {remainingMeals > 0 ? (
                    <p>Add {remainingMeals} more meals</p>
                ) : (
                    <p>You've reached your plan. Add more items if you want!</p>
                )}
                <div className={styles.progressBar}>
                    <div className={styles.progressBarItem} style={{ width: `${filledPercentage}%` }}></div>
                </div>
            </div>
        </>
    )
};